import React from "react";

import { deepForeach } from "utils/helpersReact";
import { TabsTypes } from "../types";
import { isTab } from "./typeChecker";

export function getTabsCount(children: React.ReactElement) {
    let tabCount = 0;
    deepForeach(children, (item) => {
        if(isTab(item)) {
            tabCount = tabCount + 1;
        }
    })
    return tabCount;
}